import type { WsDisplayArtifact } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { DisplayArtifact } from "@/store/types";

function transformWsDisplayArtifact(r: WsDisplayArtifact): DisplayArtifact {
  return {
    id: r.id,
    contentId: r.contentId,
    createdAt: r.createdAt ?? new Date().toISOString(),
    deletedAt: r.deletedAt ?? null,
    description: r.description ?? null,
    title: r.title,
  };
}

export async function bulkUpsertDisplayArtifact(records: WsDisplayArtifact[]) {
  if (records.length === 0) return;
  store.upsert("displayArtifact", records.map(transformWsDisplayArtifact));
}
